/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { UserEntity } from './user-entity';
export class NotificationEntity extends Entity {
  body: string | null = null;
  createdAt: string | null = null;
  emails: string | null = null;
  id: string = '';
  isRead: boolean | null = null;
  subject: string | null = null;
  type: string | null = null;
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  userId: string | null = null;
  static override key = 'Notification';
  static override get schema() {
    return {
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Notification' in input
    ) {
      const { Notification: wrapped, ...rest } = input as {
        Notification: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}